module.exports = __webpack_public_path__ + "assets/BngMUXZYTXPIvIBgJJSb6ufA5qW54A-26a6ce.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/BngMUXZYTXPIvIBgJJSb6ufA5qW54A.woff2
// module id = 867
// module chunks = 2